// Personal Assistant org enablement toggle (PA-1a).
//
// Source: docs/planning/personal_assistant_mode_plan.md §4.2
//
// Flips `organizations.personal_assistant_enabled` via
// `admin_set_personal_assistant_enabled` RPC.

import type { Dispatch, SetStateAction } from "react";

export function OrgSettingsSectionPersonalAssistant(props: {
  personalAssistantEnabled: boolean;
  setPersonalAssistantEnabled: Dispatch<SetStateAction<boolean>>;
  saving: boolean;
  onSave: () => void | Promise<void>;
}) {
  const { personalAssistantEnabled, setPersonalAssistantEnabled, saving, onSave } = props;
  return (
    <div className="pt-2 border-t border-gray-100">
      <div className="mb-3 rounded-lg border border-indigo-200 bg-indigo-50 p-3">
        <p className="text-xs font-semibold text-indigo-900">Firefly Personal Assistant</p>
        <p className="mt-1 text-[11px] text-indigo-900/80">
          When enabled, owners and admins with the Personal Assistant responsibility can use a
          multi-turn conversational assistant inside Firefly. Users still opt in per session and
          per-member via Settings. Default: disabled.
        </p>
        <label className="mt-2 inline-flex items-center gap-2 text-xs text-indigo-900">
          <input
            type="checkbox"
            checked={personalAssistantEnabled}
            onChange={(e) => setPersonalAssistantEnabled(e.target.checked)}
            disabled={saving}
          />
          Personal Assistant enabled for this organization
        </label>
        <div className="mt-2">
          <button
            type="button"
            onClick={() => void onSave()}
            disabled={saving}
            className="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-xs hover:bg-indigo-700 disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save Personal Assistant setting"}
          </button>
        </div>
      </div>
    </div>
  );
}
